module.exports = __webpack_public_path__ + "img/cloudPOSplatform.f1af6201.jpg";